import React from "react";
import "../../styles/components/TrustedCompanies.css";

import glovoLogo from "../../img/companies/glovo.png";
import skelarLogo from "../../img/companies/skelar.png";
import toyHouseLogo from "../../img/companies/toy-house.png";
import genesisLogo from "../../img/companies/genesis.png";

import company5 from "../../img/companies/company-5.png";
import company6 from "../../img/companies/company-6.png";
import company7 from "../../img/companies/company-7.png";
import company8 from "../../img/companies/company-8.png";
import company9 from "../../img/companies/company-9.png";

const companies = [
  { src: glovoLogo, alt: "Glovo", className: "tc__logo--glovo" },
  { src: skelarLogo, alt: "Skelar", className: "tc__logo--skelar" },
  { src: toyHouseLogo, alt: "Будинок Іграшок", className: "tc__logo--toyhouse" },
  { src: genesisLogo, alt: "Genesis", className: "tc__logo--genesis" },
  { src: company5, alt: "", className: "tc__logo--company5" },
  { src: company6, alt: "", className: "tc__logo--company6" },
  { src: company7, alt: "", className: "tc__logo--company7" },
  { src: company8, alt: "", className: "tc__logo--company8" },
  { src: company9, alt: "", className: "tc__logo--company9" },
];

export default function TrustedCompaniesHeader() {
  return (
    <section className="tc tc--header">
      <h2 className="tc__title tc-anim">Companies trust us</h2>

      <div className="tc__logos tc-anim">
        <div className="tc__logos-track">
          {[...companies, ...companies].map((company, index) => (
            <div className="tc__logo-item" key={`${company.className}-${index}`}>
              <img
                src={company.src}
                alt={company.alt}
                className={`tc__logo ${company.className}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}